module.exports = __webpack_public_path__ + "img/onlineCarbg1.7b3c0120.png";